import {
    AuthSuccessAction,
    AUTH_SUCCESS,
    ClearAuthAction,
    CLEAR_AUTH,
    RedirectAuthNeededAction,
    REDIRECT_AUTH_NEEDED,
    TwoFactorAuthRequiredAction,
    TWO_FACTOR_AUTH_REQUIRED,
} from '../actions/auth';
import { AuthStore } from '../types';

type AuthActionType = AuthSuccessAction | ClearAuthAction | TwoFactorAuthRequiredAction | RedirectAuthNeededAction;

export default function auth(
    state: AuthStore = {
        isLoggedIn: false,
        authCredentials: null,
        twoFactorAuthRequired: false,
        isEmailVerified: false,
        authRedirectUrl: null,
        userId: null,
    },
    action: AuthActionType,
): AuthStore {
    switch (action.type) {
        case AUTH_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                twoFactorAuthRequired: false,
                isEmailVerified: action.payload.isEmailVerified,
                userflowIdentitySignature: action.payload.userflowIdentitySignature,
                authCredentials: {
                    ...action.payload.auth,
                },
                authRedirectUrl: null,
                userId: action.payload.userId,
            };
        case CLEAR_AUTH:
            return {
                ...state,
                isLoggedIn: false,
                twoFactorAuthRequired: false,
                isEmailVerified: false,
                authCredentials: null,
                userflowIdentitySignature: null,
                authRedirectUrl: null,
                userId: null,
            };
        case TWO_FACTOR_AUTH_REQUIRED:
            return {
                ...state,
                isLoggedIn: false,
                twoFactorAuthRequired: true,
                authCredentials: null,
                authRedirectUrl: null,
                userId: action.userId,
            };
        case REDIRECT_AUTH_NEEDED:
            return {
                ...state,
                authRedirectUrl: action.payload.authRedirectUrl,
            };
        default:
            return state;
    }
}
